export default "__VITE_ASSET__MqOMPUIf__"